import SodInsights from './SodInsights';

export default SodInsights;
